
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-full h-full",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"evo-open","width":"32","height":"32","viewBox":"0 0 32 32","class":"w-full h-full"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 7.869h26m-26 8h26m-26 8h26","stroke":"currentColor","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    